"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import Cookies from "js-cookie";
import { useTrackingStore } from "@/stores";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";
import { getMobileUrl, pjppRouteConfig } from "@/utils/urls";
export default function CookieConsent() {
  const $ = _c(26);
  const {
    trackingConsent,
    setTrackingConsent
  } = useTrackingStore();
  const {
    t
  } = useTranslation();
  const mobileDomain = typeof window !== "undefined" ? getMobileUrl(window.location.host) : "";
  let t0;
  if ($[0] !== setTrackingConsent) {
    t0 = () => {
      const cookieConsent = Cookies.get("hidecookieconsent");
      if (!cookieConsent) {
        setTrackingConsent(false);
      } else {
        if (cookieConsent === "1") {
          setTrackingConsent(true);
        }
      }
    };
    $[0] = setTrackingConsent;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== trackingConsent) {
    t1 = [trackingConsent];
    $[2] = trackingConsent;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] !== setTrackingConsent) {
    t2 = () => {
      Cookies.set("hidecookieconsent", "1", {
        expires: 365
      });
      setTrackingConsent(true);
    };
    $[4] = setTrackingConsent;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleAccept = t2;
  if (trackingConsent) {
    return null;
  }
  const t3 = "fixed bottom-0 w-full py-1 px-4 text-center z-[100] bg-white border-dim-grey border-t-[1.5px]";
  const t4 = "flex justify-between md:flex md:justify-end";
  const t5 = "mr-6 text-left md:flex md:items-center flex flex-wrap content-center";
  let t6;
  if ($[6] !== t) {
    t6 = t("Experteer verwendet Cookies.");
    $[6] = t;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <p className="md:mr-2 text-sm">{t6}</p>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = isMobile ? pjppRouteConfig.mobileAboutUsPrivacy(mobileDomain) : pjppRouteConfig.desktopAboutUsPrivacy;
  let t9;
  if ($[10] !== t) {
    t9 = t("Informationen zum Datenschutz");
    $[10] = t;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t8 || $[13] !== t9) {
    t10 = <a href={t8} className="text-dark-blue text-sm" target="_blank" rel="noopener noreferrer">{t9}</a>;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t7) {
    t11 = <div className={t5}>{t7}{t10}</div>;
    $[15] = t10;
    $[16] = t7;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t) {
    t12 = t("Verstanden");
    $[18] = t;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== handleAccept || $[21] !== t12) {
    t13 = <div className="self-center text-right min-w-32"><button data-testid="cookie-consent-accept" onClick={handleAccept} className="appearance-none font-lato font-bold text-amazing-grey text-mobile-p2 px-[20px] my-1 rounded-[4px] border-dark-grey border-[1px] md:mr-6 md:py-2 md:px-10 min-h-10 md:h-10">{t12}</button></div>;
    $[20] = handleAccept;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t11 || $[24] !== t13) {
    t14 = <div className={t3}><div className={t4}>{t11}{t13}</div></div>;
    $[23] = t11;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
}